import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dc-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss']
})
export class StartupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
